import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { loadFonts } from './landing-page/components/Utils';
import { CreateRouteProvider,UserDataContextProvider } from './landing-page/components/Context';


// loadFonts();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    
        <UserDataContextProvider>
            <CreateRouteProvider>
                <App />
            </CreateRouteProvider>
        </UserDataContextProvider>
    
  
);


